// extracted by mini-css-extract-plugin
export default {"banner":"bZiKc","stage-notifications":"_3sw9I","stageNotifications":"_3sw9I"};